const PORTAL_BACKEND = process?.env?.VUE_APP_BACKEND_URL;
const AUTH_BACKEND = `${PORTAL_BACKEND}`;
const USERS_BACKEND = `${PORTAL_BACKEND}/accounts/me`;
const USERS_DASHBOARD_BACKEND = `${PORTAL_BACKEND}/dashboard/accounts/me`;
const OTP_BACKEND = `${PORTAL_BACKEND}/otp`;
const TICKET_BACKEND = `${PORTAL_BACKEND}/dashboard/tickets`;
const NETWORKS_BACKEND = `${PORTAL_BACKEND}/dashboard/networks`;
const SUBNETS_BACKEND = `${PORTAL_BACKEND}/dashboard/subnets`;
const SECURITY_GROUP_BACKEND = `${PORTAL_BACKEND}/dashboard/security_groups`;
const SECURITY_GROUP_RULES_BACKEND = `${PORTAL_BACKEND}/dashboard/security_group_rules`;
const PORTS_BACKEND = `${PORTAL_BACKEND}/dashboard/ports`;
const FLOATING_IPS_BACKEND = `${PORTAL_BACKEND}/dashboard/floating_ips`;
const ROUTERS_BACKEND = `${PORTAL_BACKEND}/dashboard/routers`;
const VOLUMES_BACKEND = `${PORTAL_BACKEND}/dashboard/volumes`;
const SNAPSHOTS_BACKEND = `${PORTAL_BACKEND}/dashboard/snapshots`;
const IMAGES_BACKEND = `${PORTAL_BACKEND}/dashboard/images`;
const KEYPAIRS_BACKEND = `${PORTAL_BACKEND}/dashboard/keypairs`;
const SERVERS_BACKEND = `${PORTAL_BACKEND}/dashboard/servers`;
const BARE_METAL_BACKEND = `${PORTAL_BACKEND}/dashboard/bare_metals`;
const FLAVORS_BACKEND = `${PORTAL_BACKEND}/dashboard/flavors`;
const BALANCE = `${PORTAL_BACKEND}/balance`;
const INVOICES = `${PORTAL_BACKEND}/invoices`;
const SUMMARIES_INVOICES = `${PORTAL_BACKEND}/summaries/invoices`;
const PAYMENTS = `${PORTAL_BACKEND}/payments`;
const ORDERS_BACKEND = `${PORTAL_BACKEND}/orders`;
const PRODUCT_BACKEND = `${PORTAL_BACKEND}/products`;
const DEPOSIT_BACKEND = `${PORTAL_BACKEND}/deposit`;
const BALANCE_BACKEND = `${PORTAL_BACKEND}/balance`;
const TASK_BACKEND = `${PORTAL_BACKEND}/dashboard/tasks`;
const SCHEDULE_SNAPSHOT_BACKEND = `${PORTAL_BACKEND}/dashboard/schedule_server_snapshots`;
const SERVER_GROUPS_BACKEND = `${PORTAL_BACKEND}/dashboard/server_groups`;
const IAM_BACKEND = `${PORTAL_BACKEND}/dashboard/iam`;
const ALERT_BACKEND = `${PORTAL_BACKEND}/dashboard/alerts`;
const COUPONS = `${PORTAL_BACKEND}/dashboard/coupons/apply`;
const SUBSCRIPTIONS = `${PORTAL_BACKEND}/subscriptions`;
const LOAD_BALANCERS = `${PORTAL_BACKEND}/dashboard/load_balancers`;
const SIMPLE_STORAGE = `${PORTAL_BACKEND}/dashboard/s3`;
const SIMPLE_STORAGE2 = `${PORTAL_BACKEND}/s3`;
const VPN_BACKEND = `${PORTAL_BACKEND}/dashboard/vpn`;
const USER_SERVICES = `${PORTAL_BACKEND}/accounts/services`;
const REGIONS = `${PORTAL_BACKEND}/regions`;
const REGION = `${PORTAL_BACKEND}/region`;
const QOS_POLICIES = `${PORTAL_BACKEND}/dashboard/qos_policies`;
const VOLUME_TYPES = `${PORTAL_BACKEND}/dashboard/volume_types`;
const REGION_SERVICES = `${PORTAL_BACKEND}/dashboard/regions`;
const SERVER_SNAPSHOTS = `${PORTAL_BACKEND}/dashboard/server_snapshots`;
const ACCOUNTS_BACKEND = `${PORTAL_BACKEND}/dashboard/accounts`;
const SUBSCRIPTION_ITEMS = `${PORTAL_BACKEND}/dashboard/subscription_items`;
const SETTINGS_BACKEND = `${PORTAL_BACKEND}/dashboard/settings`;
const INVOICE_STATUS_BACKEND = `${PORTAL_BACKEND}/accounts/invoice_status`;
const TRIAL_UPGRADE_REQUESTS_BACKEND = `${PORTAL_BACKEND}/trials/upgrades`;
const FEATURE_FLAGS_BACKEND = `${PORTAL_BACKEND}/dashboard/feature-flags`;
const RESOURCES_BACKEND = `${PORTAL_BACKEND}/dashboard/resources`;

export default {
  PORTAL_BACKEND,
  AUTH_BACKEND,
  USERS_BACKEND,
  OTP_BACKEND,
  TICKET_BACKEND,
  NETWORKS_BACKEND,
  SUBNETS_BACKEND,
  SECURITY_GROUP_BACKEND,
  SECURITY_GROUP_RULES_BACKEND,
  PORTS_BACKEND,
  FLOATING_IPS_BACKEND,
  ROUTERS_BACKEND,
  VOLUMES_BACKEND,
  SNAPSHOTS_BACKEND,
  IMAGES_BACKEND,
  KEYPAIRS_BACKEND,
  SERVERS_BACKEND,
  FLAVORS_BACKEND,
  BALANCE,
  INVOICES,
  SUMMARIES_INVOICES,
  PAYMENTS,
  ORDERS_BACKEND,
  PRODUCT_BACKEND,
  DEPOSIT_BACKEND,
  BALANCE_BACKEND,
  TASK_BACKEND,
  SCHEDULE_SNAPSHOT_BACKEND,
  SERVER_GROUPS_BACKEND,
  IAM_BACKEND,
  ALERT_BACKEND,
  COUPONS,
  SUBSCRIPTIONS,
  BARE_METAL_BACKEND,
  LOAD_BALANCERS,
  SIMPLE_STORAGE,
  SIMPLE_STORAGE2,
  VPN_BACKEND,
  USER_SERVICES,
  REGIONS,
  REGION,
  QOS_POLICIES,
  VOLUME_TYPES,
  REGION_SERVICES,
  USERS_DASHBOARD_BACKEND,
  SERVER_SNAPSHOTS,
  ACCOUNTS_BACKEND,
  SUBSCRIPTION_ITEMS,
  SETTINGS_BACKEND,
  INVOICE_STATUS_BACKEND,
  TRIAL_UPGRADE_REQUESTS_BACKEND,
  FEATURE_FLAGS_BACKEND,
  RESOURCES_BACKEND,
}
